<template v-if="parsed">
  <v-container fluid class="pa-0">
    <v-container class="pt-7">
      <h1 >
        {{ headerOne }}
      </h1>
      <div class="h1stripe">
        <div class="inner"></div>
      </div>

    </v-container>
  </v-container>
</template>
<script setup>
const props = defineProps({
  headerOne: {
    type: String,
    default: "",
  },
});
let parsed = true;
</script>

